/**
 * Almacén seguro de datos del lado del cliente.
 *
 * Algunos navegadores bloquean el acceso a localStorage en contextos
 * de terceros (Edge "Tracking Prevention", Firefox con strict mode,
 * Safari ITP). Este módulo implementa una cadena de fallback:
 *
 *   1. localStorage   — persistencia completa entre pestañas y recargas
 *   2. sessionStorage — persiste en la pestaña actual; sobrevive a F5
 *   3. Memoria (obj)  — último recurso; solo dura hasta la siguiente recarga
 *
 * En producción, el frontend y la API están en el mismo origen, por lo que
 * localStorage siempre está disponible. Este fallback aplica principalmente
 * en desarrollo local donde los puertos difieren.
 */

const _mem = {};

function _leer(storage, clave) {
  try { return storage.getItem(clave); } catch { return null; }
}

function _escribir(storage, clave, valor) {
  try { storage.setItem(clave, valor); } catch { /* ignorar */ }
}

function _borrar(storage, clave) {
  try { storage.removeItem(clave); } catch { /* ignorar */ }
}

export const almacen = {
  getItem(clave) {
    const ls = _leer(localStorage, clave);
    if (ls !== null) return ls;
    const ss = _leer(sessionStorage, clave);
    if (ss !== null) return ss;
    return _mem[clave] ?? null;
  },

  setItem(clave, valor) {
    _mem[clave] = valor;
    _escribir(sessionStorage, clave, valor);
    _escribir(localStorage, clave, valor);
  },

  removeItem(clave) {
    delete _mem[clave];
    _borrar(sessionStorage, clave);
    _borrar(localStorage, clave);
  },
};

export default almacen;
